/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskBingNewsOverviewEntry } from './ExecRiskBingNewsOverviewEntry';
import {
    ExecRiskBingNewsOverviewEntryFromJSON,
    ExecRiskBingNewsOverviewEntryFromJSONTyped,
    ExecRiskBingNewsOverviewEntryToJSON,
} from './ExecRiskBingNewsOverviewEntry';

/**
 * 
 * @export
 * @interface ExecRiskPaginatedBingResponse
 */
export interface ExecRiskPaginatedBingResponse {
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedBingResponse
     */
    total?: number;
    /**
     * 
     * @type {Array<ExecRiskBingNewsOverviewEntry>}
     * @memberof ExecRiskPaginatedBingResponse
     */
    results: Array<ExecRiskBingNewsOverviewEntry>;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskPaginatedBingResponse
     */
    schema_version?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedBingResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedBingResponse
     */
    page_size?: number;
}

/**
 * Check if a given object implements the ExecRiskPaginatedBingResponse interface.
 */
export function instanceOfExecRiskPaginatedBingResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function ExecRiskPaginatedBingResponseFromJSON(json: any): ExecRiskPaginatedBingResponse {
    return ExecRiskPaginatedBingResponseFromJSONTyped(json, false);
}

export function ExecRiskPaginatedBingResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskPaginatedBingResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': !exists(json, 'total') ? undefined : json['total'],
        'results': ((json['results'] as Array<any>).map(ExecRiskBingNewsOverviewEntryFromJSON)),
        'schema_version': !exists(json, 'schema_version') ? undefined : json['schema_version'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
    };
}

export function ExecRiskPaginatedBingResponseToJSON(value?: ExecRiskPaginatedBingResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'results': ((value.results as Array<any>).map(ExecRiskBingNewsOverviewEntryToJSON)),
        'schema_version': value.schema_version,
        'page': value.page,
        'page_size': value.page_size,
    };
}

